export default __webpack_public_path__ + "static/media/backward.c78460c1.svg";